
const jarvisOnestockDashboardConstants = {

    // Dashboard Stats Card

    JARVIS_ONESTOCK_DASHBOARD_STATS_SAGA: "JARVIS_ONESTOCK_DASHBOARD_STATS_SAGA",
    JARVIS_ONESTOCK_DASHBOARD_STATS_REQUEST: "JARVIS_ONESTOCK_DASHBOARD_STATS_REQUEST",
    JARVIS_ONESTOCK_DASHBOARD_STATS_RESPONSE: "JARVIS_ONESTOCK_DASHBOARD_STATS_RESPONSE",
    JARVIS_ONESTOCK_DASHBOARD_STATS_API: "/onestock/dashboard/portfolio-stats",

// Dashboard table statsv2
    JARVIS_ONESTOCK_DASHBOARD_STATSV2_SAGA: "JARVIS_ONESTOCK_DASHBOARD_STATSV2_SAGA",
    JARVIS_ONESTOCK_DASHBOARD_STATSV2_REQUEST: "JARVIS_ONESTOCK_DASHBOARD_STATSV2_REQUEST",
    JARVIS_ONESTOCK_DASHBOARD_STATSV2_RESPONSE: "JARVIS_ONESTOCK_DASHBOARD_STATSV2_RESPONSE",
    JARVIS_ONESTOCK_DASHBOARD_STATSV2_API: "/onestock/dashboard/portfolio-statsV2",

    // JARVIS_ONESTOCK_DASHBOARD_STATSV2_SAGA: "JARVIS_ONESTOCK_DASHBOARD_STATSV2_SAGA",
    // JARVIS_ONESTOCK_DASHBOARD_STATSV2_REQUEST: "JARVIS_ONESTOCK_DASHBOARD_TABLE_REQUEST",
    // JARVIS_ONESTOCK_DASHBOARD_TABLE_RESPONSE: "JARVIS_ONESTOCK_DASHBOARD_TABLE_RESPONSE",
    // JARVIS_ONESTOCK_DASHBOARD_TABLE_API: "onestock/dashboard/portfolio-statsV2",

    // Dashboard Portfolio Reveal

    JARVIS_ONESTOCK_DASHBOARD_REVEAL_SAGA: "JARVIS_ONESTOCK_DASHBOARD_REVEAL_SAGA",
    JARVIS_ONESTOCK_DASHBOARD_REVEAL_REQUEST: "JARVIS_ONESTOCK_DASHBOARD_REVEAL_REQUEST",
    JARVIS_ONESTOCK_DASHBOARD_REVEAL_RESPONSE: "JARVIS_ONESTOCK_DASHBOARD_REVEAL_RESPONSE",
    JARVIS_ONESTOCK_DASHBOARD_REVEAL_API: "/onestock/dashboard/portfolio-reveal",

    // For Buy Call

    JARVIS_ONESTOCK_CALL_API: "/onestock/action-centre"

};

export { jarvisOnestockDashboardConstants };
